export default __webpack_public_path__ + "static/media/Thief's Legguards of the Swift Return.b78911f1.jpg";